// =====================================================================
// lieuPlan.js — le lieu d'un accident touché sur le plan (24-10-2026, demande Silviu :
// « in modulul declaratie de accident nu mai vreau sa scanam un emplacement »)
// =====================================================================
// Règles pures, testées. Miroir du serveur (safety-incident.service.js : exigerLieu, MSG_LIEU_REQUIS).
// =====================================================================

export const MSG_LIEU_REQUIS = 'Indiquez où c’est arrivé : touchez le plan, ou décrivez l’endroit.';

/** Le lieu d'une fiche qui n'a qu'un point sur le plan (liste, fiche, registre imprimé). */
export const LIBELLE_POINT = 'point marqué sur le plan';

/** Coordonnée normalisée bornée à 0..1 (un clic au bord de l'image reste sur le plan). */
export const borne = (v) => Math.min(1, Math.max(0, v));

/**
 * L'objet du plan le plus proche du point touché (coordonnées 0..1). Une zone (rack, aire :
 * planX2 / planY2) qui CONTIENT le point gagne ; sinon le centre le plus proche. Les objets sans
 * position sont ignorés. `null` s'il n'y a rien.
 */
export function plusProche(objets, x, y) {
  let meilleur = null; let distance = Infinity;
  for (const o of objets || []) {
    if (o.planX == null || o.planY == null) continue;
    const zone = o.planX2 != null && o.planY2 != null;
    let d;
    if (zone) {
      const [x1, x2] = [Math.min(o.planX, o.planX2), Math.max(o.planX, o.planX2)];
      const [y1, y2] = [Math.min(o.planY, o.planY2), Math.max(o.planY, o.planY2)];
      d = (x >= x1 && x <= x2 && y >= y1 && y <= y2) ? 0 : Math.hypot((x1 + x2) / 2 - x, (y1 + y2) / 2 - y);
    } else {
      d = Math.hypot(o.planX - x, o.planY - y);
    }
    if (d < distance) { distance = d; meilleur = o; }
  }
  return meilleur;
}

/** Le texte proposé après le toucher : « près de : Rack R12 (réserve) ». */
export const texteProche = (o) => (o ? `près de : ${o.name}${o.zone ? ` (${o.zone})` : ''}` : '');

/** Le registre exige le lieu (3°) : l'objet du QR, un point sur le plan, ou quelques mots. */
export function erreurLieu({ asset, lieu, locationText }) {
  if (asset || lieu || (locationText && locationText.trim().length >= 3)) return null;
  return MSG_LIEU_REQUIS;
}
